import React, { useEffect, useState } from "react";
import CategoryToolbar from "./toolbar";
import CategoryCard from "./card";
import { getMerchantCategories } from "../../api/axios/requests";
import AddCategoryModal from "../../modals/add-category";
import { useModalManager } from "../../hooks/useModalManager";
import EditCategoryModal from "../../modals/edit-category";
import DeleteCategoryModal from "../../modals/delete-category";
import { useSearchParams } from "react-router-dom";
import EmptyStateComponent from "../../components/empty";

export default function CategoryManageScreen() {
  const [loading, setLoading] = useState(false);
  const [categories, setCategories] = useState([]);
  const [activeCat, setActiveCat] = useState({});
  const [selectedCat, setSelectedCat] = useState({});
  // Аль баганаас «Нэмэх» дарснаас хамаарч parentId: дээд түвшин → null (root),
  // дэд багана → activeCat.id (хүүхэд). Өмнө нь ХОЁУЛАА activeCat.id ашиглаж,
  // дээд түвшний «Нэмэх» буруугаар хүүхэд болгон үүсгэдэг байв.
  const [addParentId, setAddParentId] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();

  const { closeModal, currentModal, openModal } = useModalManager();

  useEffect(() => {
    const loadCategories = async () => {
      setLoading(true);
      try {
        const res = await getMerchantCategories();
        if (res.success) {
          setCategories(res.data);
        }
      } catch (err) {
        console.error("Merchant info татаж чадсангүй:", err);
      } finally {
        setLoading(false);
      }
    };
    loadCategories();
  }, []);

  const onSelect = (category) => {
    if (!category) return;
    setActiveCat(category);
    searchParams.set("cat", category.id);
    setSearchParams(searchParams);
  };
  const onEditClick = (category) => {
    setSelectedCat(category);
    openModal("edit-category");
  };
  const onDeleteClick = (category) => {
    setSelectedCat(category);
    openModal("delete-category");
  };

  const catId = searchParams.get("cat");

  return (
    <div className="container-fluid app">
      <div className="row">
        <div className="col-12">
          <CategoryToolbar
            search={""}
            setSearch={() => {}}
            selectedCategory={""}
            handleCategoryChange={() => {}}
            categories={""}
            loadingCategories={false}
            categoriesError={false}
            onRefetch={() => {}}
          />
          <h4 className="page-title mt-3">Ангилал засах</h4>
        </div>
      </div>
      <div className="row">
        <CategoryCard
          loading={loading}
          title="Ангилал"
          onAddClick={() => {
            setAddParentId(null); // дээд түвшин → root
            openModal("add-category");
          }}
          onEditClick={onEditClick}
          onDeleteClick={onDeleteClick}
          categories={categories}
          onSelect={onSelect}
        />
        {catId ? (
          <CategoryCard
            title={activeCat.name}
            onAddClick={() => {
              setAddParentId(activeCat.id); // дэд багана → хүүхэд
              openModal("add-category");
            }}
            onEditClick={onEditClick}
            onDeleteClick={onDeleteClick}
            loading={loading}
            categories={activeCat.children}
            onSelect={null}
          />
        ) : (
          <div className="col-lg-6 col-md-12">
            <div className="card">
              <div className="card-body pt-0">
                <div className="table-responsive mt-n2">
                  <EmptyStateComponent title="Ангилал сонгоно уу" />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <AddCategoryModal
        show={currentModal === "add-category"}
        handleClose={closeModal}
        parentId={addParentId}
      />
      <EditCategoryModal
        show={currentModal === "edit-category"}
        handleClose={closeModal}
        category={selectedCat}
      />
      <DeleteCategoryModal
        show={currentModal === "delete-category"}
        handleClose={closeModal}
        category={selectedCat}
      />
    </div>
  );
}
